import { jsx as _jsx } from "react/jsx-runtime";
const EmptyState = () => /*#__PURE__*/_jsx("span", {
  "data-test-id": "empty-state",
  children: "--"
});
export default EmptyState;